import preloader from '../blocks/preloader/preloader';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import button from '../blocks/button';
import SliderSquare from '../blocks/slider-square';
import SliderGallery from '../blocks/slider-gallery';
import SliderAccordion from './SliderAccordion';
import NewsSlider from '../blocks/news-slider';
import AlbumSlider from '../blocks/album-slider';
import Header from '../blocks/header';
import InteractiveMap from '../blocks/interactive-map';
import ProfilePage from '../blocks/profile-page';
import NewsPage from '../blocks/news-page';
import MobileSlider from './MobileSlider';
import CardsSection from '../blocks/tournament-page/cards-section';
import Video from '../blocks/video';
import 'fancybox/dist/js/jquery.fancybox.js';

const mobileSliderInstances = [
	{selector: '.event-slider'},
	{selector: '.tournament-slider'},
	{selector: '.place-slider'}
];

const accordeonSliderInstances = [
	{selector: '.slider-coaches'},
	{selector: '.slider-holes', responsiveImages: true}
];

$(() => {
	svg4everybody();

	const sliderSquare = new SliderSquare();
	sliderSquare.makeSlider();

	const header = new Header();
	header.init();

	const interactiveMap = new InteractiveMap();
	interactiveMap.init();

	const newsSlider = new NewsSlider();
	newsSlider.makeSlider();

	const albumSlider = new AlbumSlider();
	albumSlider.makeSlider();

	const profilePage = new ProfilePage();
	profilePage.init();

	const newsPage = new NewsPage();
	newsPage.init();

	mobileSliderInstances.forEach(instance => {
		const mobileSlider = new MobileSlider(instance);
		mobileSlider.makeSlider();
	});

	CardsSection.init();

	const sliderGallery = new SliderGallery();
	sliderGallery.makeSlider();

	accordeonSliderInstances.forEach(instance => {
		const sliderAccordion = new SliderAccordion(instance);
		sliderAccordion.makeSlider();
	});

	Video.init();

	button();

	preloader();

	$('.js-fancybox').fancybox({
		tpl: {
			next: '<a title="Следующая картинка" class="fancybox-nav fancybox-next"><button></button></a>',
			prev: '<a title="Предыдущая картинка" class="fancybox-nav fancybox-prev"><button></button></a>',
			closeBtn: '<a title="Закрыть" class="fancybox-item fancybox-close"></a>'
		}
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js